var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "trigger" }, [
    _c("div", { staticClass: "button filter-btn" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.toggleLabel) + "\n\n\t\t"),
      _c(
        "svg",
        {
          attrs: {
            width: "8",
            height: "5",
            viewBox: "0 0 8 5",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M3.32031 3.98438C3.49609 4.16016 3.78906 4.16016 3.96484 3.98438L7.10938 0.859375C7.28516 0.664062 7.28516 0.371094 7.10938 0.195312C6.91406 0 6.62109 0 6.44531 0.195312L3.65234 2.98828L0.859375 0.195312C0.664062 0 0.371094 0 0.195312 0.195312C0 0.371094 0 0.664062 0.195312 0.839844L3.32031 3.98438Z",
              fill: "currentColor",
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "popup" }, [
      _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }